import * as Enumerable from 'linq';
import {
  TYPE, MONTHLY_DAYS_COUNT, SECTION_LOCOMO_NAMES, SECTION_ADL_NAMES, MAX_LOCOMO_CNT, MAX_ADL_CNT,
  LOCOMO_MIN_NO, LOCOMO_MAX_NO, ADL_MIN_NO, ADL_MAX_NO
} from '../constants/Training';

interface CountData {
  h_month: number[][];
  h_month_date: number[];
  num_td: number;
}

// モフトレ通信用.
interface MoffTrainingData {
  badge: number;
  maxTrainingId: number;
  trainingCountArr: number[];
  maxTrainingCount: number;

  // LocomoとADLが完了してから取得する(両方のデータのため).
  historyDateFlag: boolean[];
}

// monthly_count_dataの移植.
// APIから返却された月間ロコモ/ADLの変換用.
export class MonthlyCountData {
  // トレーニング種目 (locomo, adl)
  public type: TYPE = TYPE.None;

  // カウント用テーブル
  public historyTable: number[][] = [];

  // 角度用テーブル
  public historyTableAngle: number[][] = [];

  // 日付記録有無テーブル
  public dateFlag: boolean[] = [];

  // 長期変化用.
  public historyTableLongterm: string[][] = [];
  public historyTableAngleLongterm: string[][] = [];

  // 配列番号用に差し引く数 (注意: 0番台がロコモ、100番台が日常生活トレーニング )
  private minusTrainingId: number = 0;

  // コンストラクタ
  constructor(type: TYPE) {
    // カウント用テーブル
    this.historyTable = [];
    this.historyTableLongterm = [];
    // 角度用テーブル
    this.historyTableAngle = [];
    this.historyTableAngleLongterm = [];
    // 日付記録有無テーブル
    this.dateFlag = [];
    // トレーニング種目 (locomo, adl)
    this.type = type;

    // トレーニングの項目数.
    let numTraining: number = 0; 

    // メニュー毎にURLと配列番号用に差し引く数をセット.
    if (this.type === TYPE.Locomo) {
      this.minusTrainingId = LOCOMO_MIN_NO;
      // 項目数.
      numTraining = MAX_LOCOMO_CNT;
    } else if (this.type === TYPE.ADL) {
      this.minusTrainingId = ADL_MIN_NO;
      // 項目数.
      numTraining = MAX_ADL_CNT;
    }

    // カウント用 <numTraining>行32列の配列を初期化
    for (let i = 0; i < numTraining; i++) {
      this.historyTable.push(new Array(MONTHLY_DAYS_COUNT).fill(0));
      this.historyTableLongterm.push([]);
    }
 
    // 角度用 7行32列の配列を初期化
    for (let i = 0; i < numTraining; i++) {
      this.historyTableAngle.push(new Array(MONTHLY_DAYS_COUNT).fill(0));
      this.historyTableAngleLongterm.push([]);
    }
 
    // 日付に記録があるかどうか
    this.dateFlag = new Array(MONTHLY_DAYS_COUNT).fill(false);
  }

  // 詳細用.
  insertData = (history: any) => {
    // null or undefinedを禁止.
    if (!history) {
      return;
    }

    for (const date of Object.keys(history)) {
      // 日付から日を切り取る(2017-07-30 => 30).
      const dateNum: number = Number(date.substring(8, 10));
      // 日付有無チェック.
      this.dateFlag[dateNum] = true;

      for (const trainingId of Object.keys(history[date])) {
        const trainingIdNum = Number(trainingId);
        const historyTableIndex = trainingIdNum - this.minusTrainingId;

        // Locomo, ADLの項目内にあるものだけ表示.
        if ((trainingIdNum >= LOCOMO_MIN_NO && trainingIdNum <= LOCOMO_MAX_NO)
          || (trainingIdNum >= ADL_MIN_NO && trainingIdNum <= ADL_MAX_NO)) {
          // カウント数を入れる.
          this.historyTable[historyTableIndex][dateNum] = history[date][trainingId].count;
          // 角度を入れる.
          this.historyTableAngle[historyTableIndex][dateNum] = history[date][trainingId].average_angle;
        } else {
          continue;
        }
      }
    }
  }

  // 長期変化用.
  insertDataLongterm = (histories: any) => {
    // null or undefinedを禁止.
    if (!histories) {
      return;
    }

    for (let i: number = 0; i < histories.length; i++) {
      const history: any[] = histories[i];
      // null or undefinedを禁止.
      if (!history) {
        return;
      }

      // ソートしないと順序が日付順にならない.
      Enumerable.from(history).orderBy(item => item.key).toArray().forEach((item: any) => {
        // item.key: 2017-11-07
        const date: string = item.key;

        for (const trainingId of Object.keys(history[date])) {
          const trainingIdNum = Number(trainingId);
          const historyTableIndex = trainingIdNum - this.minusTrainingId;

          // Locomo, ADLの項目内にあるものだけ表示.
          if ((trainingIdNum >= LOCOMO_MIN_NO && trainingIdNum <= LOCOMO_MAX_NO)
            || (trainingIdNum >= ADL_MIN_NO && trainingIdNum <= ADL_MAX_NO)) {
            // カウント数を入れる.
            this.historyTableLongterm[historyTableIndex][date] = history[date][trainingId].count;

            // 角度を入れる.
            this.historyTableAngleLongterm[historyTableIndex][date] = history[date][trainingId].average_angle;
          } else {
            continue;
          }
        }
      });
    }
  }

  divideHistoryMonthTable = (historyDateFlag: any, historyMonthly: any,
                             di1: number, di2: number, numRows: number, numCols: number): CountData => {
    // 分割分のテーブル
    const hMonth: number[][] = [];
    const hMonthDate: number[] = [];
    for (let i = 0; i < numRows; i++) {
      hMonth.push(new Array(numCols).fill(0));
    }
 
    // Trueの数
    let numTd = 0;
    for (let i = 0; i < historyDateFlag.length; i++) {
      if (historyDateFlag[i] && i > 0) {
        numTd++;
        if (numTd > di1 && numTd <= di2) {
          for (let tid = 0; tid < numRows; tid++) {
            hMonth[tid][numTd - 1 - di1] = historyMonthly[tid][i];
          }
          hMonthDate[numTd - 1 - di1] = i;
        }
      }
    }

    return {
      h_month: hMonth,
      h_month_date: hMonthDate,
      num_td: numTd
    } as CountData;
  }
 
  divideHistoryMonthTables = (historyDateFlagStart: any, historyMonthlyStart: any,
                              NUM_ROWS: number, NUM_COLS: number, NUM_TABLES: number): CountData[] => {
    const mData: CountData[] = [];
    for (let i = 0; i < NUM_TABLES; i++) {
      const indexStart = NUM_COLS * i;
      let indexEnd = NUM_COLS * (i + 1);
      if (i === NUM_TABLES - 1) {
        indexEnd = 31;
      }

      mData[i] = this.divideHistoryMonthTable(
        historyDateFlagStart, historyMonthlyStart, indexStart, indexEnd, NUM_ROWS, NUM_COLS);
    }

    return mData;
  }
 
  dataSize = (obj: object): number => {
    // Lambdaからデータ取得できなかったとき.
    if (obj === null) {
      return -2;
    }

    let size = 0, key;
    for (key in obj) {
      if (obj.hasOwnProperty(key)) { size++; }
    }
    return size;
  }

  /**
   * モフトレ通信で使うトレーニングの回数を取得する.
   *
   * @memberof MonthlyCountData
   */
  getMoffTrainingCounts = (history: any): MoffTrainingData => {
    this.insertData(history);

    let badge: number = Math.floor(Math.random() * (3 + 1 - 1)) + 1;

    // 各トレーニング(ロコモ, ADL)の要素数.
    let trainingCount: number = 0;
    if (this.type === TYPE.Locomo) {
      trainingCount = SECTION_LOCOMO_NAMES.length;
    } else if (this.type === TYPE.ADL) {
      trainingCount = SECTION_ADL_NAMES.length;
    }

    // undefinedにならないように各要素を0回で初期化.
    const trainingCountArr: number[] = new Array(trainingCount).fill(0);
    let maxTrainingId: number = 0;
    let historyDateFlag: boolean[] = [];
    let maxTrainingCount: number = 0;

    // 各トレーニング毎.
    for (let trainingIdx = 0; trainingIdx < trainingCount; trainingIdx++) {
      for (let dayIdx = 0; dayIdx < MONTHLY_DAYS_COUNT; dayIdx++) {
        const tmp = Number(this.historyTable[trainingIdx][dayIdx]);
        trainingCountArr[trainingIdx] += tmp;
      }
      if (trainingIdx === 0) {
        maxTrainingId = trainingIdx;
        maxTrainingCount = trainingCountArr[trainingIdx];
      }

      // モフトレ通信のBEST1用に使う数字の処理.
      if (trainingIdx > 0 && maxTrainingCount < trainingCountArr[trainingIdx]) {
        maxTrainingId = trainingIdx;
        maxTrainingCount = trainingCountArr[trainingIdx];
      }
    }

    if (maxTrainingCount === 0) {
      badge = 0;
    }

    // 日付に記録があるかどうか(カレンダー表示をロコモとADLで共通化)
    if (historyDateFlag.length > 0) {
      for (let i = 0; i < this.dateFlag.length; i++) {
        if (this.dateFlag[i]) {
          historyDateFlag[i] = this.dateFlag[i];
        }
      }
    } else {
      historyDateFlag = this.dateFlag;
    }

    return {
      badge: badge,
      maxTrainingId: maxTrainingId,
      trainingCountArr: trainingCountArr,
      maxTrainingCount: maxTrainingCount,
      historyDateFlag: historyDateFlag
    } as MoffTrainingData;
  }
}



// WEBPACK FOOTER //
// ./src/utils/MonthlyCountData.tsx